module.exports = __webpack_public_path__ + "static/media/door-closed.4f9265d0.svg";